import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  axiomTokens,
  Button,
  Dialog,
  DialogActions,
} from '@iclinic/design-system';
import { Form, FormikProvider, useFormik } from 'formik';

import {
  closeAddressModal,
  goBackToConfirmationModal,
  openPharmasOffCanvas,
  setOptInAddressData,
} from 'features/free-samples/state/opt-in-confirmation';
import AddressFormFields from './AddressFormFields';
import { addressValidationSchema } from './validation';
import { OptInAddressData } from 'features/free-samples/services/types';
import * as S from './styles';
import {
  getOptInAddressData,
  getOptInPersonalData,
} from 'features/free-samples/state/opt-in-confirmation/selectors';

const { color } = axiomTokens;

const AddressModal = () => {
  const dispatch = useDispatch();
  const personalData = useSelector(getOptInPersonalData);
  const clinicAddress = useSelector(getOptInAddressData);

  const handleCloseModal = () => {
    dispatch(closeAddressModal());
  };

  const handleBack = () => {
    dispatch(goBackToConfirmationModal());
  };

  const handleSubmit = (formData: OptInAddressData) => {
    dispatch(setOptInAddressData(formData));
    dispatch(openPharmasOffCanvas());
  };

  const initialValues: OptInAddressData = {
    phone_number: clinicAddress?.phone_number ?? '',
    zip_code: clinicAddress?.zip_code ?? personalData?.zip_code ?? '',
    state: clinicAddress?.state ?? '',
    city: clinicAddress?.city ?? '',
    neighborhood: clinicAddress?.neighborhood ?? '',
    address: clinicAddress?.address ?? '',
    number: clinicAddress?.number ?? '',
    complement: clinicAddress?.complement ?? '',
    is_clinic_address: clinicAddress?.is_clinic_address ?? false,
  };

  const formik = useFormik({
    initialValues,
    validationSchema: addressValidationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <FormikProvider value={formik}>
      <Form>
        <Dialog open onClose={handleCloseModal} maxWidth="sm">
          <S.DialogHeader
            onClose={handleCloseModal}
            title="Receba amostras grátis"
          />
          <S.DialogContent>
            <AddressFormFields />
          </S.DialogContent>

          <DialogActions>
            <Button
              style={{ color: color.typeface.pure }}
              color="transparent"
              onClick={handleBack}
            >
              Voltar
            </Button>

            <Button
              onClick={() => {
                formik.setFieldTouched('is_clinic_address', true);
                formik.handleSubmit();
              }}
            >
              Quero receber amostras
            </Button>
          </DialogActions>
        </Dialog>
      </Form>
    </FormikProvider>
  );
};
export default AddressModal;
